import { z } from "zod";

/**
 * Custom HTTP headers — stored in AgentExternalTool.customHeaders Json field.
 *
 * A flat header-name → value map applied to EVERY action of a CUSTOM_MANIFEST
 * external tool, independent of (and merged before) the auth headers. The
 * primary use case is letting a tool author set a browser-like `User-Agent`
 * (plus `Accept` / `Accept-Language`) so anti-bot WAFs (Workday, Cloudflare,
 * Akamai, …) don't fingerprint Nexus egress as a bot and return 403. See
 * NEX-2017.
 *
 * Keys must be non-empty; values are sent verbatim.
 */
export const ToolCustomHeadersSchema = z.record(z.string().min(1), z.string());

export type ToolCustomHeaders = z.infer<typeof ToolCustomHeadersSchema>;
